// test2943
(2943 && 0);
